import React from "react"

export  default function NotFound(props) {
    return (
        <>
            <h1>Resource Not Found</h1>
        </>
    )
}
